var _rect, _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlashaPayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.53516,
    y: 8.75781,
    width: 25.3359,
    height: 16.8906,
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70703 10.9297H10.0852",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3203 23.4766L27.6984 23.4766",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2024,
    cy: 17.2034,
    r: 1.60863,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.01,
    cy: 26.7033,
    r: 8.39669,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 0.730147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6443 30.5331C30.8811 30.5331 30.1961 30.06 29.9184 29.3414L29.5587 28.4116C29.5218 28.3271 29.4826 28.2724 29.4411 28.247C29.3994 28.2216 29.3317 28.209 29.2382 28.209H29.0781L28.9833 28.995C28.8773 29.873 28.1402 30.5331 27.2656 30.5331L28.0001 24.491C28.1067 23.613 28.8442 22.9531 29.7191 22.9531L29.2034 27.2014H29.3084C29.3953 27.2014 29.4652 27.1879 29.5187 27.161C29.572 27.1341 29.6256 27.0851 29.6789 27.0141L30.4313 25.9716C30.7397 25.5444 31.23 25.2905 31.7529 25.2876L32.6329 25.2825L31.1809 27.1509C31.114 27.2387 31.0407 27.3165 30.9605 27.3838C30.8804 27.4514 30.7968 27.5105 30.7102 27.561C30.7804 27.6185 30.8412 27.6851 30.8929 27.761C30.9447 27.8369 30.9905 27.924 31.0305 28.0219L32.0719 30.5334H31.6443V30.5331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlashaPayIcon);
export default __webpack_public_path__ + "static/media/klasha-pay-icon.a821d59cdac288499b43870663a26e38.svg";
export { ForwardRef as ReactComponent };